import { Space, Button } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddKYCPresetForm from './AddKYCPresetForm';

export type AddKYCPresetsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const AddKYCPresetDrawer = ({ onClose, visible, moduleId }: AddKYCPresetsDrawerProps) => {
    const { t } = useTranslation(['localCustomerModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('localCustomerModuleDetails:kycPresetsDrawer.cancelButton')}</Button>
                    <Button form="addKYCPresets" htmlType="submit" type="primary">
                        {t('localCustomerModuleDetails:kycPresetsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('localCustomerModuleDetails:kycPresetsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddKYCPresetForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default AddKYCPresetDrawer;

export const useAddKYCPresetDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <AddKYCPresetDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
